<div class="blogs-insights-container">
  <div class="header">
    <h2>
      Inforida<span> blogs,</span> <br />
      insights & more<span>.</span>
    </h2>
    <!-- <a href="https://blog.inforida.com/" target="_blank" mat-button color="primary">See all</a> -->
  </div>

  <div class="blogs-grid">
    <!-- Blog 1 -->
    <div class="blog-card" (click)="openBlogLink(1)">
      <!-- <img
        src="../../../assets/images/pexels-emily-ranquist-493228-1205651.jpg"
        alt="Blog Image 1"
      /> -->
      <div class="background-image one-image"></div>
      <div class="blog-content">
        <h3 class="blog-title">A Decade in Review</h3>
        <p class="blog-date">May 13, 2024</p>
        <p class="blog-description">
          Analysing CBSE Class 10th and 12th Results with Data Visualisation...
        </p>
        <a (click)="openBlogLink(1)">Read More →</a>
      </div>
    </div>

    <!-- Blog 3 -->
    <div class="blog-card" (click)="openBlogLink(2)">
      <!-- <img
        src="../../../assets/images/pexels-tima-miroshnichenko-5428148.jpg"
        alt="Blog Image 3"
      /> -->
      <div class="background-image two-image"></div>
      <div class="blog-content">
        <h3 class="blog-title">The Secret to School Success</h3>
        <p class="blog-date">Feb 18, 2023</p>
        <p class="blog-description">
          As schools continue to adapt to the ever-evolving world of education,
          the role of technology has become more important than ever before...
        </p>
        <a (click)="openBlogLink(2)">Read More →</a>
      </div>
    </div>

    <!-- Blog 2 -->
    <div class="blog-card" (click)="openBlogLink(3)">
      <!-- <img src="../../../assets/images/ved-blog-1.png" alt="Blog Image 2" />
        -->
      <div class="background-image three-image"></div>
      <div class="blog-content">
        <h3 class="blog-title">
          5 Ways Inforida Can Make Teacher's Lives Easier
        </h3>
        <p class="blog-date">September 28, 2014</p>
        <p class="blog-description">
          Teachers, you're the heart and soul of education. You inspire young
          minds, nurture curiosity, and help students blossom into their full
          potential...
        </p>
        <a (click)="openBlogLink(3)">Read More →</a>
      </div>
    </div>
    <!-- Blog 4 -->
    <div class="blog-card" (click)="openBlogLink(4)">
      <!-- <img
        src="https://blog.inforida.com/content/images/size/w750/2024/04/pexels-rdne-stock-project-5922675.jpg"
        alt="Blog Image 4"
      /> -->
      <div class="background-image four-image"></div>
      <div class="blog-content">
        <h3 class="blog-title">Mastering School Finances with Inforida</h3>
        <p class="blog-date">May 10, 2024</p>
        <p class="blog-description">
          Managing finances effectively is a critical aspect of running a school
          smoothly...
        </p>
        <a (click)="openBlogLink(4)">Read More →</a>
      </div>
    </div>
  </div>

  <div class="more-blogs" (click)="openBlogLink(5)">See more blogs →</div>
</div>
